import * as React from 'react'

export const FaqIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8.00586C4 6.90129 4.89543 6.00586 6 6.00586H34C35.1046 6.00586 36 6.90129 36 8.00586V12.0059H42C43.1046 12.0059 44 12.9013 44 14.0059V34.0059C44 35.1104 43.1046 36.0059 42 36.0059H40V41.9972C40 43.7066 37.9945 44.6282 36.6974 43.5149L27.949 36.0059H13.0607L11.3026 37.5149C10.0055 38.6282 8 37.7066 8 35.9972V30.0059H6C4.89543 30.0059 4 29.1104 4 28.0059V8.00586ZM16.5558 33.0059H29.06L37 39.821V33.0059H41V15.0059H36V28.0059C36 29.1104 35.1046 30.0059 34 30.0059H20.051L16.5558 33.0059ZM22 24.5059C22 25.6104 21.1046 26.5059 20 26.5059C18.8954 26.5059 18 25.6104 18 24.5059C18 23.4013 18.8954 22.5059 20 22.5059C21.1046 22.5059 22 23.4013 22 24.5059ZM20.9505 20.0057H19.0105C18.7105 20.0057 18.5505 19.8457 18.5505 19.5257C18.6105 17.9857 19.0105 17.2857 20.1305 16.2657L20.8905 15.5657C21.3505 15.1457 21.8105 14.5457 21.8105 13.6857C21.8105 12.8057 21.1705 12.1257 20.1105 12.1257C19.0105 12.1257 18.4105 12.7457 18.3105 13.8257C18.2705 14.1257 18.1105 14.2857 17.8305 14.2857H15.6305C15.3305 14.2857 15.1505 14.1257 15.1705 13.8057C15.4105 11.2057 17.2105 9.60571 20.1905 9.60571C23.3305 9.60571 25.0505 11.3857 25.0505 13.6257C25.0505 15.0857 24.3705 16.2657 23.1105 17.2457L22.9305 17.3857C21.9505 18.1457 21.5105 18.6057 21.4105 19.5457C21.3905 19.8457 21.2305 20.0057 20.9505 20.0057Z"
        fill="#0070E0"
      />
    </svg>
  )
})

FaqIcon.displayName = 'FaqIcon'
